import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareOs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShareOs"><Path d="M12 0.657715L17.3102 6.28031L16.2197 7.31024L12.75 3.63644V14H11.25V3.63644L7.78029 7.31024L6.68977 6.28031L12 0.657715Z" fill="currentColor"/><Path d="M4 9.00002H9.75V15.5H14.25V9.00002H20V21H4V9.00002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareOs;
